import { ReactNode } from 'react';
import { PanelWrapper } from './Popover.styles';

interface PopoverPanelProps {
  children: ReactNode;
}

const PopoverPanel = ({ children }: PopoverPanelProps) => (
  <PanelWrapper>{children}</PanelWrapper>
);

export { PanelContentWrapper } from './Popover.styles';
export { PopoverPanel };
